"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOST_RESPONSE_CODES = exports.MAX_WORLDPAY_RETRIES = void 0;
exports.MAX_WORLDPAY_RETRIES = 120;
exports.HOST_RESPONSE_CODES = {
    '00': 'Approved',
    '01': 'Call for voice authorization',
    '02': `Refer to Issuer's Special Conditions`,
    '03': 'Merchant id Invalid',
    '04': 'Pick Up Card',
    '05': 'Bank Decline',
    '06': 'Error',
    '07': 'Pick Up Card, Special Conditions',
    '09': 'Request in Progress',
    '10': 'Partial Amount Approved',
    '12': 'Invalid Transaction',
    '13': 'Invalid Amount',
    '14': 'Invalid Card Number',
    '15': 'No Such Issuer',
    '17': 'Customer Cancellation',
    '18': 'Customer Dispute',
    '19': 'Re-enter Transaction',
    '20': 'Invalid Response',
    '21': 'No Action Taken',
    '22': 'Suspected Malfunction',
    '23': 'Unacceptable Transaction Fee',
    '24': 'File Update not Supported by Receiver',
    '25': 'Unable to Locate Record on File',
    '26': 'Duplicate File Update Record',
    '27': 'File Update Field Edit Error',
    '28': 'File Update File Locked Out',
    '29': 'File Update Not Successful',
    '30': 'Format Error',
    '31': 'Bank not Supported by Switch',
    '32': 'Completed Partially',
    '33': 'Expired Card - Pick up',
    '34': 'Suspected Fraud - Pick up',
    '35': 'Contact Acquirer - Pick Up',
    '36': 'Restricted Card - Pick up',
    '37': 'Call Acquirer Security - Pick up',
    '38': 'Allowable PIN Tries Exceeded',
    '39': 'No CREDIT Account',
    '40': 'Requested Function not Supported',
    '41': 'Lost Card - Pick Up',
    '42': 'No Universal Amount',
    '43': 'Stolen Card - Pick Up',
    '44': 'No investment Account',
    '51': 'Insufficient Funds',
    '52': 'No Check Account - Occurs when the debit/check card card being attempted is not linked to a Checking Account',
    '53': 'No Savings Account',
    '54': 'Expired Card',
    '55': 'Incorrect PIN',
    '56': 'No Card Record',
    '57': 'Transaction not Permitted to Cardholder',
    '58': 'Transaction not Permitted to Terminal',
    '59': 'Suspected Fraud',
    '60': 'Card Acceptor Contact Acquirer',
    '61': 'Exceeds Withdrawal Amount Limits',
    '62': 'Restricted Card',
    '63': 'Security Violation',
    '64': 'Original Amount Incorrect',
    '65': 'Exceeds Withdrawal Frequency Limit',
    '66': 'Card Acceptor Call Acquirer Security',
    '67': 'Hard Capture - Pick up Card at ATM',
    '68': 'Response Received Too Late',
    '70': 'Invalid transaction; contact card issuer',
    '75': 'Allowable PIN Tries Exceeded',
    '86': 'ATM Malfunction',
    '87': 'No Envelope Inserted',
    '88': 'Unable to Dispense',
    '89': 'Administration Error',
    '90': 'Cut-off in Progress',
    '92': 'Financial Institution not Found',
    '93': 'Transaction Cannot be Completed',
    '94': 'Duplicate Transaction',
    '95': 'Reconcile Error',
    '96': 'System Malfunction',
    '97': 'Reconciliation Totals Reset',
    '98': 'Error',
    '99': 'Reserved for National Use',
};
//# sourceMappingURL=constants.js.map